export function showMessage(data) {
    alert(data.message + (data.description ? ": " + data.description : ""));
}